import { createClient } from '@supabase/supabase-js';

const CONFIG = {
  SUPABASE_URL: 'https://vhvkaisivmqxvljteyou.supabase.co',
  SUPABASE_ANON_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZodmthaXNpdm1xeHZsanRleW91Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEyODM1NTQsImV4cCI6MjA2Njg1OTU1NH0.7xLHNe6Yzm0ynp5kx57ZlNhe22HjIl9pwMMpbA0RBsA'
};

export const supabase = createClient(CONFIG.SUPABASE_URL, CONFIG.SUPABASE_ANON_KEY);
